// A 10-digit Indian mobile, with any +91 / 91 / 0 prefix and separators dropped; null otherwise.
// Same rules as the server (JJWEBAPI MobileNumber.ToTenDigit) and LeadFlowPro, so the number a lead
// types here and the number the rep shared compare equal.
export function normalizeMobile(raw) {
  let d = String(raw || "").replace(/\D/g, "");
  if (d.length === 12 && d.startsWith("91")) d = d.slice(2);
  else if (d.length === 11 && d.startsWith("0")) d = d.slice(1);
  return d.length === 10 && d[0] >= "6" ? d : null;
}

export const showMobile = (m) => (m && m.length === 10 ? `${m.slice(0, 5)} ${m.slice(5)}` : m || "");
